module.exports = __webpack_public_path__ + "ba.svg?d5ef14f05acaac11a4844e9b3bbedb00";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/ba.svg
// module id = 1243
// module chunks = 0